import * as React from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import { API_BASE_URL } from "../api/config";
import { rawFetch } from "../api/httpClient";

export const VisioList = () => {
  const [bookingId, setBookingId] = React.useState("");
  const [userId, setUserId] = React.useState("");
  const [config, setConfig] = React.useState(null);

  const fetchVideoConfig = async () => {
    if (!bookingId.trim() || !userId.trim()) return;
    setConfig(null);
    try {
      const params = new URLSearchParams({ userId: userId.trim() });
      const res = await rawFetch(`${API_BASE_URL}/consultation/${bookingId.trim()}/video?${params}`, {
        headers: { "X-React-Admin": "true" },
      });
      if (!res.ok) throw new Error(await res.text());
      const json = await res.json();
      setConfig(json);
    } catch (e) {
      setConfig({ error: e.message });
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <VideoCallIcon /> Visioconférence
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        GET /consultation/{"{bookingId}"}/video?userId — roomName, roomOpen, moderator. Upload extrait : POST /consultation/{"{bookingId}"}/video-extract (FormData).
      </Alert>
      <Box sx={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
        <TextField size="small" label="Booking ID" value={bookingId} onChange={(e) => setBookingId(e.target.value)} />
        <TextField size="small" label="User ID" value={userId} onChange={(e) => setUserId(e.target.value)} />
        <Button variant="contained" onClick={fetchVideoConfig}>Config salle</Button>
      </Box>
      {config && (
        <Paper sx={{ p: 2, mt: 2 }}>
          {config.error ? (
            <Typography color="error">{config.error}</Typography>
          ) : (
            <pre style={{ fontSize: 12 }}>{JSON.stringify(config, null, 2)}</pre>
          )}
        </Paper>
      )}
    </Box>
  );
};
